import React from "react";
import { render } from "react-dom";
import axios from "axios";
import history from "./utils/history";
import App from "./components/App";
import configureStore from "./redux/configureStore";
import { Provider as ReduxProvider } from "react-redux";
import { createConsumer } from "@rails/actioncable";
import * as Sentry from "@sentry/react";
import { Integrations as TracingIntegrations } from "@sentry/tracing";
import { ReactQueryDevtools } from "react-query/devtools";
import { QueryClient, QueryClientProvider } from "react-query";

/* Assets */
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import "./assets/css/style.css";
import "./assets/scss/style.scss";

// import "./assets/css/custom.css";
// import "./assets/css/side-bar.css";
// import "./assets/css/top-bar.css";
// import "./assets/css/page-titles.css";
// import "./assets/css/table.css";
// import "./assets/css/pagination.css";
// import "./assets/js/waves.js";
// import "./assets/js/sidebarmenu.js";
// import "./assets/js/custom.js";
// import "./assets/css/pages/dashboard1.css";
// import "./assets/css/pages/login-register-lock.css";
// import "./assets/css/toogle-switch.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Notification from "./components/common/Notification";
import Cookies from "js-cookie";

if (window.location.host.split(".")[0] === "admin") {
  axios.defaults.baseURL = process.env.ADMIN_API_URL;
} else {
  axios.defaults.baseURL = process.env.API_URL;
}
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});
const store = configureStore();
const cableApp = {};
cableApp.cable = createConsumer(process.env.CABLE_URL);
Sentry.init({
  dsn: process.env.SENTRY_DSN,
  release: "console-web@0.1.1",
  environment: process.env.NODE_ENV,
  integrations: [new TracingIntegrations.BrowserTracing()],
  ignoreErrors: ["Request failed with status code 401"],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 0.5,
});

const UNAUTHORIZED = 401;
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const { status } = error.response;
    if (status === UNAUTHORIZED && location.pathname !== "/login") {
      queryClient.clear();
      Cookies.set("jwt", "");
      localStorage.setItem("jwt", "");
      localStorage.setItem("upgradeAlertDismissed", "false");
      history.push(`/login`);
    }
    return Promise.reject(error);
  }
);

render(
  <ReduxProvider store={store}>
    <QueryClientProvider client={queryClient}>
      <App cableApp={cableApp} />
      <Notification />
      <ReactQueryDevtools initialIsOpen={true} />
    </QueryClientProvider>
  </ReduxProvider>,
  document.getElementById("app")
);
